const selectPhonecallStatusOptions = [
  { id: '1', name: 'Pendente' },
  { id: '2', name: 'Retornar ligação' },
  { id: '3', name: 'Finalizada' },
];

export default selectPhonecallStatusOptions;
